export default __webpack_public_path__ + "static/media/of_5.6a76a309.mp3";